import {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {HideProgressLoading} from "../../../components/template/architecture";
import {PostJSON, ServerImage} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import {BreadCrumbs} from "../../../components/open/pages";

export const HomeNewsViewScreen = () => {
    const {newsNd} = useParams();
    const [data, setData] = useState({
        loaded: false,
        title: '',
        category: '',
        img: '',
        createdAt: '',
        body: '',
        signup: false,
    });
    const navigate = useNavigate();
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/home/news/get',
            {
                nd: newsNd,
            },
            false,
            (d: {
                result: string,
                reason: string,
                title: string,
                category: string,
                img: string,
                createdAt: string,
                body: string,
                hasSignup: 0 | 1,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'not-found') {
                        navigate('/news', {replace: true});
                        ShowSnackbar(
                            'اطلاعیه یافت نشد',
                            'باشه',
                            5000,
                        );
                    }
                    return;
                }
                document.title = d.title + " | شهاب مدرسه زندگی";
                setData({
                    body: d.body,
                    category: d.category,
                    img: d.img,
                    createdAt: d.createdAt,
                    title: d.title,
                    loaded: true,
                    signup: d.hasSignup === 1,
                });
            },
            () => {
            },
            () => {
            },
        ).then(void 0);
    };
    useEffect(() => {
        fetchData();
    }, []);
    return (
        <>
            <div style={{background: '#fff'}}>
                <div className="container-big">
                    <BreadCrumbs links={[
                        {title: 'اطلاعیه ها', url: '/news'},
                        {title: data.loaded ? data.title : '...', url: `/news/view/${newsNd}`},
                    ]}/>
                </div>
            </div>
            {
                data.loaded ?
                    <div className="home-news-view">
                        <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                            <div className="row">
                                <div className="col-lg-4">
                                    <img src={ServerImage(data.img, 500)} alt={data.title}/>
                                    <div className="d-lg-none" style={{height: 40}}/>
                                </div>
                                <div className="col-lg-8">
                                    <h1>{data.title}</h1>
                                    <i>{data.category}</i>
                                    <em>{StringDigitsConvertToPersian(GregorianToPersian(data.createdAt.split(' ')[0]).replaceAll('-', '/'))}</em>
                                    <p>{data.body}</p>
                                    {
                                        data.signup ?
                                            <div className="d-flex justify-content-end align-items-center"
                                                 style={{marginTop: 30}}>
                                                <Link to={`/students/news/view/${newsNd}`} className="btn-pay">
                                                    <b>ثبت نام</b>
                                                </Link>
                                            </div> : null
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    : null
            }
        </>
    );
};